class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* ---- CNC: header open-state mirror (speed fix 2026-10-07). Lives here because this file loads on every page;
   it replaces the html:has(...) rules in cnc-dawn-overrides.css. See the comment below. ---- */
/* cnc-has-state.js — mirrors header drawer / modal open state onto <html> classes.
   Replaces the :has() selectors on <html> in cnc-dawn-overrides.css. A :has() whose subject is <html> makes Chrome
   re-style the whole document on every DOM insertion anywhere (measured 2026-10-07 on the BBB shop page:
   29-46 ms per insertion unthrottled, 1.2 ms with these classes). This observer only listens to the two
   attributes that change the state, and runs in the same microtask checkpoint as the change, so the look
   updates in the same frame as before. */
(function () {
  var root = document.documentElement;
  function has(sel) { return !!document.querySelector(sel); }
  function sync() {
    root.classList.toggle('cnc-menu-open', has('.menu-drawer-container[open]'));
    root.classList.toggle('cnc-modal-open', has('details-modal[open]'));
    root.classList.toggle('cnc-menu-summary-open', has('details[open] > summary.header__icon--menu'));
    root.classList.toggle('cnc-menu-expanded', has('summary.header__icon--menu[aria-expanded="true"]'));
  }
  new MutationObserver(sync).observe(root, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-expanded'] });
  sync();
})();
